import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import "./HomeSlider.scss";

function HomeSlider() {
  return (
    <div className="home-slider">
      <div
        id="slide"
        className="carousel slide carousel-fade"
        data-bs-ride="carousel"
      >
        <div className="carousel-indicators">
          <button
            type="button"
            data-bs-target="#slide"
            data-bs-slide-to="0"
            className="active"
            aria-current="true"
            aria-label="Slide 1"
          ></button>
          <button
            type="button"
            data-bs-target="#slide"
            data-bs-slide-to="1"
            aria-label="Slide 2"
          ></button>
          <button
            type="button"
            data-bs-target="#slide"
            data-bs-slide-to="2"
            aria-label="Slide 3"
          ></button>
        </div>
        <div className="carousel-inner">
          <div className="carousel-item active">
            <img src="/img/a54.jpg" className="d-block w-100" alt="..." />
            <div className="carousel-caption ">
              <p>CASUAL WEAR ESSENTIALS OF 2021</p>
              <a href="#product-section">
                <button>SHOP NOW</button>
              </a>
            </div>
          </div>
          <div className="carousel-item">
            <img src="/img/a56.JPEG" className="d-block w-100" alt="..." />
            <div className="carousel-caption ">
              <p>CASUAL WEAR ESSENTIALS OF 2021</p>
              <a href="#product-section">
                <button>SHOP NOW</button>
              </a>
            </div>
          </div>
          <div className="carousel-item">
            <img src="/img/a53.JPEG" className="d-block w-100" alt="..." />
            <div className="carousel-caption">
              <p>CASUAL WEAR ESSENTIALS OF 2021</p>
              <a href="#product-section">
                <button>SHOP NOW</button>
              </a>
            </div>
          </div>
        </div>
        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#slide"
          data-bs-slide="prev"
        >
          <span
            className="carousel-control-prev-icon "
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#slide"
          data-bs-slide="next"
        >
          <span
            className="carousel-control-next-icon"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>
    </div>
  );
}

export default HomeSlider;
